(function () {
    'use strict';

    /**
     * Featured stories section - owns its data and loading.
     * Used as an attribute on the server rendered <section> (Views/Events/_FeaturedStories.cshtml).
     * No template and a child scope, so the Razor markup inside binds to "featuredStoriesSection"
     * and still sees the page "vm" (getStyle, showLoading).
     */
    angular
        .module('EventListApp')
        .directive('wsSectionFeaturedStories', sectionFeaturedStories);

    function sectionFeaturedStories() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionFeaturedStoriesCtrl,
            controllerAs: 'featuredStoriesSection'
        };
    }

    SectionFeaturedStoriesCtrl.$inject = ['$element', 'ApiFactory', 'SectionRegistry'];

    function SectionFeaturedStoriesCtrl($element, ApiFactory, SectionRegistry) {
        const vm = this;
        vm.items = [];

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        /**
         * The article url of a story
         * @param {object} story
         * @returns {string}
         */
        vm.getStoryURL = function (story) {
            if (story.storyURL)
                return story.storyURL;

            story.storyURL = 'a/' + story.articleID;
            return story.storyURL;
        };

        /**
         * Offset classes that center the last, not full, row of stories
         * @param {number} index the story index
         * @returns {string}
         */
        vm.storiesClass = function (index) {
            const length = vm.items.length;
            if (length == 0 || length == undefined)
                return '';

            let cssClass = "";
            // calc offset for last line
            // if last line that is less then 4 then add offset to the first item
            let mod = length % 4;
            if (mod > 0)
                if (index == length - mod)
                    switch (mod) {
                        case 1:
                            cssClass += ' offset-lg-4half';
                            break;
                        case 2:
                            cssClass += ' offset-lg-3';
                            break;
                        case 3:
                            cssClass += ' offset-lg-1half';
                    }

            mod = length % 3;
            if (mod > 0)
                if (index == length - mod)
                    switch (mod) {
                        case 1:
                            cssClass += ' offset-md-4 offset-lg-0';
                            break;
                        case 2:
                            cssClass += ' offset-md-2 offset-lg-0';
                            break;
                    }

            mod = length % 2;
            if (mod > 0)
                if (index == length - mod)
                    cssClass += ' offset-sm-3 offset-md-0';

            return cssClass;
        };

        /**
         * Load the featured stories of the event
         * @param {number} eventId
         * @param {number} lang
         * @returns {Promise}
         */
        function load(eventId, lang) {
            return ApiFactory.GetFeaturedStories(eventId, lang).then(function (response) {
                vm.items = response.data;
            });
        }
    }
})();
